import React, { useState } from "react";
import BasicMatchingInformation from "./basicMatchingInformation/basic-matching-information";
import Rationale from "./rationale/rationale";
import CareNeeds from "./careNeeds/care-needs";
import ChildPenPicture from "./childPenPicture/child-pen-picture";
import ViolenceTowardsStafF from "./consideredAreas/violence-towards-staff";
import EducationalNeeds from "./educationalNeeds/educational-needs";
import PhysicalAndEmotional from "./physicalAndEmotional/physical-and-emotional";
import Contact from "./contact/contact";
import LittleNorwayHome from "./littleNorwayHome/little-norway-home";
import PotentialImpact from "./potentialImpact/potential-impact";
import InformationSharing from "./informationSharing/information-sharing";
import ViolenceTowardsPeers from "./consideredAreas/violence-towards-peers";
import PropertyDamage from "./consideredAreas/property-damage";
import SelfCalm from "./consideredAreas/self-calm";
import Absconding from "./consideredAreas/absconding";
import SubstanceMisuse from "./consideredAreas/substance-misuse";
import Offending from "./consideredAreas/offending";
import Sexually from "./consideredAreas/sexually";
import BullyingBehaviour from "./consideredAreas/bullying-behaviour";
import Vulnerability from "./consideredAreas/vulnerability";
import AllegationsPeer from "./consideredAreas/allegations-peer";
import AllegationsStaff from "./consideredAreas/allegations-staff";
import FireSetting from "./consideredAreas/fire-setting";
import EmotionallyRegulate from "./consideredAreas/emotionally-regulate";
import SexualExploitation from "./consideredAreas/sexual-exploitation";
import Radicalization from "./consideredAreas/radicalization";
import PeerRelationship from "./consideredAreas/peer-relationship";

const MatchingAssesmentForm = () => {
  const [currentStep, setCurrentStep] = useState(0); // Step index
  const [formData, setFormData] = useState({
    basicmatchingInfo: {},
    rationalInfo: {},
    violenceTowardsStaffInfo: {},
    violenceTowardsPeersInfo: {},
    propertyDamageInfo: {},
    selfCalmInfo: {},
    abscondingInfo: {},
    substanceMisuseInfo: {},
    offendingInfo: {},
    sexuallyInfo: {},
    bullyingBehaviourInfo: {},
    vulnerabilityInfo: {},
    allegationsPeerInfo: {},
    allegationsStaffInfo: {},
    fireSettingInfo: {},
    emotionallyRegulateInfo: {},
    sexualExploitationInfo: {},
    radicalizationInfo: {},
    peerRelationshipInfo: {},
    childPenPictureInfo: {},
    careNeedsInfo: {},
    educationalNeedsInfo: {},
    physicalAndEmotionalInfo: {},
    contactInfo: {},
    littleNorwayHomeInfo: {},
    potentialImpactInfo: {},
    informationSharingInfo: {},
  });

  const nextStep = () => {
    setCurrentStep(currentStep + 1);
  };

  const prevStep = () => {
    setCurrentStep(currentStep - 1);
  };

  // Update data for each form
  const updateFormData = (newData) => {
    setFormData((prevState) => ({
      ...prevState,
      ...newData,
    }));
  };

  console.log("formData", formData);

  const handleSubmit = () => {
    console.log("Final Form Data:", formData);
  };

  // Rendering forms based on step
  const renderForm = () => {
    switch (currentStep) {
      case 0:
        return <BasicMatchingInformation updateFormData={updateFormData} nextStep={nextStep} />;
      case 1:
        return <Rationale updateFormData={updateFormData} nextStep={nextStep} prevStep={prevStep} />;
      case 2:
        return <ViolenceTowardsStafF updateFormData={updateFormData} nextStep={nextStep} prevStep={prevStep} />;
      case 3:
        return <ViolenceTowardsPeers updateFormData={updateFormData} nextStep={nextStep} prevStep={prevStep} />;
      case 4:
        return <PropertyDamage updateFormData={updateFormData} nextStep={nextStep} prevStep={prevStep} />;
      case 5:
        return <SelfCalm updateFormData={updateFormData} nextStep={nextStep} prevStep={prevStep} />;
      case 6:
        return <Absconding updateFormData={updateFormData} nextStep={nextStep} prevStep={prevStep} />;
      case 7:
        return <SubstanceMisuse updateFormData={updateFormData} nextStep={nextStep} prevStep={prevStep} />;
      case 8:
        return <Offending updateFormData={updateFormData} nextStep={nextStep} prevStep={prevStep} />;
      case 9:
        return <Sexually updateFormData={updateFormData} nextStep={nextStep} prevStep={prevStep} />;
      case 10:
        return <BullyingBehaviour updateFormData={updateFormData} nextStep={nextStep} prevStep={prevStep} />;
      case 11:
        return <Vulnerability updateFormData={updateFormData} nextStep={nextStep} prevStep={prevStep} />;
      case 12:
        return <AllegationsPeer updateFormData={updateFormData} nextStep={nextStep} prevStep={prevStep} />;
      case 13:
        return <AllegationsStaff updateFormData={updateFormData} nextStep={nextStep} prevStep={prevStep} />;
      case 14:
        return <FireSetting updateFormData={updateFormData} nextStep={nextStep} prevStep={prevStep} />;
      case 15:
        return <EmotionallyRegulate updateFormData={updateFormData} nextStep={nextStep} prevStep={prevStep} />;
      case 16:
        return <SexualExploitation updateFormData={updateFormData} nextStep={nextStep} prevStep={prevStep} />;
      case 17:
        return <Radicalization updateFormData={updateFormData} nextStep={nextStep} prevStep={prevStep} />;
      case 18:
        return <PeerRelationship updateFormData={updateFormData} nextStep={nextStep} prevStep={prevStep} />;
      case 19:
        return <ChildPenPicture updateFormData={updateFormData} nextStep={nextStep} prevStep={prevStep} />;
      case 20:
        return <CareNeeds updateFormData={updateFormData} nextStep={nextStep} prevStep={prevStep} />;
      case 21:
        return <EducationalNeeds updateFormData={updateFormData} nextStep={nextStep} prevStep={prevStep} />;
      case 22:
        return <PhysicalAndEmotional updateFormData={updateFormData} nextStep={nextStep} prevStep={prevStep} />;
      case 23:
        return <Contact updateFormData={updateFormData} nextStep={nextStep} prevStep={prevStep} />;
      case 24:
        return <LittleNorwayHome updateFormData={updateFormData} nextStep={nextStep} prevStep={prevStep} />;
      case 25:
        return <PotentialImpact updateFormData={updateFormData} nextStep={nextStep} prevStep={prevStep} />;
      case 26:
        return <InformationSharing updateFormData={updateFormData} prevStep={prevStep} handleSubmit={handleSubmit} />;
      default:
        return null;
    }
  };

  return <div>{renderForm()}</div>;
};

export default MatchingAssesmentForm;
